import PropTypes from 'prop-types';
import Header from 'components/Header';
import Webflow from 'components/Webflow';
import BlogHeader from 'components/BlogHeader';

const Default = ({ children }) => (
  <>
    <Webflow>
      <div className="flex flex-col">
        <Header />
        <main className="flex-grow">
          <BlogHeader />
          {children}
        </main>
      </div>
    </Webflow>
  </>
);

Default.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Default;
